var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar-nav-icon',{attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }